// routes.js
//
// Paths that are both declared in App.js AND navigated to from elsewhere.
//
// These exist because a hardcoded '/login' shipped a 404: the route is actually
// '/loginpage', and the unit test asserting the navigation encoded the same
// wrong guess, so it passed while the page was broken. A constant used by the
// <Route> and by every navigation makes that class of mistake impossible —
// rename the path in one place and both sides move together.
//
// Only paths referenced from more than one file need to live here.
export const ROUTES = {
  LOGIN: '/loginpage',
  REGISTER: '/registerpage',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  VERIFY_EMAIL: '/verify-email',
  PROFILE: '/profilepage',
};
